import {FeedbackStructureQuestionFormQuestion, FeedbackStructureQuestionOption} from '../feedback-structure-create-update-dialog/feedback-structure-question/feedback-structure-question-form.model';

export function feedbackAnswerControlName(question: FeedbackStructureQuestionFormQuestion, prefix: string): string {
	return `${prefix}_question_${question.position}_answer`;
}

export function feedbackCommentControlName(question: FeedbackStructureQuestionFormQuestion, prefix: string): string {
	return `${prefix}_question_${question.position}_comment`;
}

export function feedbackOptionCommentControlName(
	question: FeedbackStructureQuestionFormQuestion,
	option: FeedbackStructureQuestionOption,
	prefix: string
): string {
	return `${prefix}_question_${question.position}_option_${option.position}_comment`;
}

export function feedbackOptionControlName(
	question: FeedbackStructureQuestionFormQuestion,
	option: FeedbackStructureQuestionOption,
	prefix: string
): string {
	return `${prefix}_question_${question.position}_option_${option.position}`;
}

export function previewAnswerControlName(question: FeedbackStructureQuestionFormQuestion): string {
	return feedbackAnswerControlName(question, 'preview');
}

export function previewCommentControlName(question: FeedbackStructureQuestionFormQuestion): string {
	return feedbackCommentControlName(question, 'preview');
}

export function previewOptionCommentControlName(
	question: FeedbackStructureQuestionFormQuestion,
	option: FeedbackStructureQuestionOption
): string {
	return feedbackOptionCommentControlName(question, option, 'preview');
}

export function previewOptionControlName(
	question: FeedbackStructureQuestionFormQuestion,
	option: FeedbackStructureQuestionOption
): string {
	return feedbackOptionControlName(question, option, 'preview');
}

export function previewOptionLabel(option: FeedbackStructureQuestionOption, fallback: string): string {
	const label = option.label?.trim();
	return label ? label : `${fallback} ${option.position + 1}`;
}
